var __jsx = React.createElement;
import { cn } from '@lib/cn';
import useCssModules from '@lib/hooks/use-css-modules';
import React from 'react';
const MuscleQuantityToggler = _ref => {
  let {
    value,
    incrementValue,
    decrementValue,
    minValue = -1 * Infinity,
    maxValue = Infinity,
    incrementDisabled = false,
    decrementDisabled = false,
    dataTestId
  } = _ref;
  const {
    cssModules
  } = useCssModules();
  const {
    passengersQuantitySelectorContainer
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.views.mobile.PassengerSelection) || {};
  return __jsx("div", {
    className: passengersQuantitySelectorContainer
  }, __jsx(QuantityTogglerCircleButton, {
    onClick: decrementValue,
    char: "-",
    disabled: value === minValue || decrementDisabled,
    dataTestId: dataTestId + "-decrement-button"
  }), __jsx("p", {
    className: cn('text-primary_text flex-1 text-center', {
      "tx-psm-regular": value <= 0,
      "tx-psm-semiBold": value > 0
    })
  }, value), __jsx(QuantityTogglerCircleButton, {
    onClick: incrementValue,
    char: "+",
    disabled: value === maxValue || incrementDisabled,
    dataTestId: dataTestId + "-increment-button"
  }));
};
const QuantityTogglerCircleButton = _ref2 => {
  let {
    onClick,
    char,
    disabled,
    dataTestId
  } = _ref2;
  const {
    cssModules
  } = useCssModules();
  const {
    passengersQuantitySelectorButton,
    passengersQuantitySelectorButtonIcon
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.views.mobile.PassengerSelection) || {};
  return __jsx("button", {
    "data-testid": dataTestId,
    className: passengersQuantitySelectorButton,
    onClick: onClick,
    disabled: disabled
  }, __jsx("span", {
    className: passengersQuantitySelectorButtonIcon
  }, char));
};
export default MuscleQuantityToggler;